import { observer } from "mobx-react-lite";

import { AppDialog } from "@/components/common";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useTran } from "@/hooks";

import { useEsgDashboardStore } from "../../hooks";

const MetricsModal = observer(() => {
  const { t } = useTran();
  const { metricsModalOpen, metricsList, closeMetricsModal } =
    useEsgDashboardStore();

  return (
    <AppDialog
      open={metricsModalOpen}
      onOpenChange={(open) => {
        if (!open) closeMetricsModal();
      }}
      title={t("Metric Details")}
      description={t("Quick snapshot of top tracked ESG metrics.")}
      size="lg"
      footer={
        <Button type="button" variant="outline" onClick={closeMetricsModal}>
          {t("Close")}
        </Button>
      }
    >
      <div className="space-y-3">
        {metricsList.map((metric) => (
          <div
            key={metric.code}
            className="flex flex-wrap items-center justify-between gap-3 rounded-radius border border-border p-3"
          >
            <div>
              <p className="text-sm font-semibold text-foreground">
                {metric.title}
              </p>
              <p className="text-xs text-muted-foreground">{metric.code}</p>
            </div>
            <div className="flex items-center gap-2">
              <Badge variant="outline">{metric.category}</Badge>
              <Badge className="bg-primary text-primary-foreground">
                {metric.progress}%
              </Badge>
            </div>
          </div>
        ))}
      </div>
    </AppDialog>
  );
});

export default MetricsModal;
